module.exports = __webpack_public_path__ + "static/media/a20_wba.3dd8e913.png";